export function defaultOptionsValues() {
  return {
    drawDonut: true,
    halfDonut: true,
  };
}
